import { render, staticRenderFns } from "./OwalButtonToggle.vue?vue&type=template&id=0632ea83&scoped=true"
import script from "./OwalButtonToggle.vue?vue&type=script&lang=js"
export * from "./OwalButtonToggle.vue?vue&type=script&lang=js"
import style0 from "./OwalButtonToggle.vue?vue&type=style&index=0&id=0632ea83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0632ea83",
  null
  
)

export default component.exports